import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLockOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 18 18" {...props}>
    {/* Lock shackle (open - left side lifted) */}
    <path d="M13 8V5C13 2.79 11.21 1 9 1S5 2.79 5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    {/* Lock body (outline) */}
    <rect x="3" y="8" width="12" height="8" rx="2" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
export default SvgLockOpen;
